import { Grid, GridItem, HStack, Text, TextProps } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

type TextWrapperProps = { children: React.ReactNode } & TextProps;
export const TextWrapper = ({ children, ...textProps }: TextWrapperProps) => {
  if (typeof children === 'string') {
    return <Text {...textProps}>{children}</Text>;
  }
  return <>{children}</>;
};

type UnderlinedHeaderProps = {
  title: React.ReactNode;
  endLabel?: React.ReactNode;
  icon?: string;
};
export const UnderlinedHeader = ({
  title,
  endLabel,
  icon = 'circle-dollar',
}: UnderlinedHeaderProps) => (
  <Grid
    gridTemplateColumns={`repeat(${endLabel ? 6 : 3}, 1fr)`}
    w="100%"
    mb="24px"
  >
    <GridItem
      colSpan={3}
      paddingBottom="4px"
      borderBottom={`1px solid ${colors.aurora[400]}`}
    >
      <HStack w="100%">
        <Icon
          icon={icon}
          color={colors.aurora[400]}
          size="large"
          type="solid"
        />
        <TextWrapper fontWeight="semibold" color={colors.aurora[400]} ml="8px">
          {title}
        </TextWrapper>
      </HStack>
    </GridItem>
    {endLabel && (
      <GridItem
        colSpan={3}
        textAlign="right"
        paddingBottom="4px"
        borderBottom={`1px solid ${colors.aurora[400]}`}
      >
        <TextWrapper fontWeight="semibold">{endLabel}</TextWrapper>
      </GridItem>
    )}
  </Grid>
);
